import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RutasPrivadas } from '../../../routes/rutasPrivadas/rutasPrivadas';
import validator from 'validator';
import { iniciarSesion, iniciarSesionElsa } from '../../../actions/auth/auth.actions';
import { iniciarSesionElsaRequest } from '../../../models/auth/auth.models';
import { guardarToken } from '../../../reducer/tokenReducer/token.reducer';
import { Alerta } from '../../../helpers/alerts/alert';
import logoGDAR from '../../../assets/logo/grupoDARlogo.webp'
import { nuevoInicioSesion } from '../../../reducer/authReducer/auth.reducer';

export type LoginProps = {
	// types...
}

const Login: React.FC<LoginProps> = () => {
	const [cargando, setCargando] = useState(false);
	const [inicioSesionElsaForm, setInicioSesionElsaForm] = useState<iniciarSesionElsaRequest>({
		email: '',
		password: '',
	});

	const { email, password } = inicioSesionElsaForm;
	const [emailError, setEmailError] = useState("");
	const [passwordError, setPasswordError] = useState("");

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const handleInputChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = target;
		setInicioSesionElsaForm((prevState: any) => {
			return {
				...prevState,
				[name]: value
			}
		});
	};

	const validarFormulario = () => {
		let esValido = true;

		if (!email.trim()) {
			setEmailError('El correo se encuentra vacío');
			esValido = false;
		} else if (!validator.isEmail(email)) {
			setEmailError('Correo electrónico inválido');
			esValido = false;		
		} else {
			setEmailError('');
		}

		if (!password.trim()) {
			setPasswordError('El campo de contraseña se encuentra vacío');
			esValido = false;
		} else {
			setPasswordError('');
		}

		return esValido;
	};

	const iniciarSesionAsync = async () => {
		try {
			if (validarFormulario()) {
				setCargando(true);
				const response = await iniciarSesionElsa(inicioSesionElsaForm)
				if (response.success) {
					const resp = await iniciarSesion({ correo: email, idUsuarioElsa: response.idUser, origen: 'webadmin', nombre: "" });
					if (resp.success) {
						let token: string = resp.data.token;
						dispatch(guardarToken(token));
						dispatch(nuevoInicioSesion({
							correo: email,
							nombreUsuario: response.mensaje
						}));

						Alerta(resp.message, resp.success)
						setCargando(false);
						setTimeout(() => {
							navigate(`/${RutasPrivadas.PRIVATE}`, { replace: true });
						}, 2500);
					}else{
						setCargando(false);
						Alerta(resp.mensaje, false)
					}
				} else {
					setCargando(false);
					Alerta(response.mensaje, false)
				}
			}
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<div className='grid lg:grid-cols-2 h-screen'>
			{/* Logo y Bienvenida */}
			<div className='lg:flex lg:flex-col md:hidden hidden flex-col justify-center align-middle items-center bg-DarkBlue'>
				<div className='flex justify-center gap-2'>
					<img src={logoGDAR} alt="GDAR" className=' h-64' />
				</div>
			</div>
			{/* Formulario de Inicio de Sesión */}
			<div className='flex flex-col justify-center align-middle items-center lg:p-0 md:p-10 p-0'>
				<div className='flex flex-col gap-5 shadow-xl border-2 rounded-2xl p-5'>
					<div className='flex flex-col justify-center align-middle items-center'>
						<h1 className='text-lg font-semibold'>Bienvenido</h1>
					</div>
					<div className="text-base space-y-4 text-gray-700">
						<div>
							<label htmlFor="email" className="mb-2 text-sm font-semibold text-gray-900">Correo institucional:</label>
							<input id="email" required
								onChange={handleInputChange} name="email" type="email" className="peer placeholder-transparent h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:borer-rose-600 p-2" />
							{
								emailError && (
									<h1 className=' text-sm pt-2 text-red-500'>{emailError}</h1>
								)
							}
						</div>
						<div>
							<label htmlFor="password" className="mb-2 text-sm font-semibold text-gray-900">Contraseña:</label>
							<input id="password" onChange={handleInputChange} name="password" type="password" className="peer placeholder-transparent h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:borer-rose-600 p-2" />
							{
								passwordError && (
									<h1 className=' text-sm pt-2 text-red-500'>{passwordError}</h1>
								)
							}
						</div>
						<div>
							<button
								onClick={iniciarSesionAsync}
								className="flex flex-row w-full gap-5 justify-center items-center align-middle rounded-md bg-DarkBlue px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
							>
								{cargando && (
									<div>
										<span className="loading loading-spinner loading-xs"></span>
									</div>
								)}
								Ingresar
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Login;
